import Reflux from 'reflux';

const GettingStartedActions = Reflux.createActions({
  getStatus: { asyncResult: true },
  dismiss: { asyncResult: true },
});

export default GettingStartedActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/gettingstarted/GettingStartedActions.js